import { render, staticRenderFns } from "./SosUserSelect.vue?vue&type=template&id=5885b6ce&scoped=true&lang=pug"
import script from "./SosUserSelect.vue?vue&type=script&lang=js"
export * from "./SosUserSelect.vue?vue&type=script&lang=js"
import style0 from "./SosUserSelect.vue?vue&type=style&index=0&id=5885b6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885b6ce",
  null
  
)

export default component.exports